import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-product-badge',
    templateUrl: './product-badge.component.html'
})
export class ProductBadgeComponent {
  @Input() content: string;
}
